export const getEventId = () => {
  return 'evt_' + Date.now() + '_' + Math.floor(Math.random() * 1000000);
};
